export default __webpack_public_path__ + "static/media/shreyash-image.33b344f3.png";